import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTissueSample = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 13.283c.717-.348 2.493-.782 3.85.264 1.358 1.046 1.39 2.875 1.237 3.657-.15.783-.118 2.61 1.24 3.655 1.354 1.046 3.133.612 3.85.264m5.637-10.76a4.181 4.181 0 1 0-3.796-5.927 3.136 3.136 0 1 0 .966 4.821 4.164 4.164 0 0 0 2.835 1.107h-.005Zm-1.463 6.272a.627.627 0 1 1 0-1.255.627.627 0 0 1 0 1.255ZM3.81 7.855a.627.627 0 1 1 0-1.254.627.627 0 0 1 0 1.254Zm17.56 11.288a.627.627 0 1 1 0-1.254.627.627 0 0 1 0 1.254Z",
		stroke: "currentColor",
		strokeWidth: 2.146,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgTissueSample;
